import React, { useEffect, useState } from 'react';
import { fetchEnrichedProducts } from '../../services/productFeed';
import { Loader2, ExternalLink } from 'lucide-react';

const OutputFeed = () => {
    const [enrichments, setEnrichments] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        loadEnrichments();
    }, []);

    const loadEnrichments = async () => {
        try {
            setLoading(true);
            const data = await fetchEnrichedProducts();
            setEnrichments(data);
            setError(null);
        } catch (err) {
            setError('Failed to load enriched products');
        } finally {
            setLoading(false);
        }
    };

    if (loading) {
        return (
            <div className="flex flex-col items-center justify-center h-full text-gray-500">
                <Loader2 className="w-8 h-8 animate-spin mb-2" />
                <p>Loading enriched products...</p>
            </div>
        );
    }

    if (error) {
        return (
            <div className="flex flex-col items-center justify-center h-full text-red-500">
                <p>{error}</p>
                <button 
                    onClick={loadEnrichments}
                    className="mt-4 px-4 py-2 bg-red-100 text-red-700 rounded-lg hover:bg-red-200 transition-colors"
                >
                    Retry
                </button>
            </div>
        );
    }

    return (
        <div className="p-6 h-full overflow-y-auto">
            <div className="mb-6">
                <h2 className="text-2xl font-bold text-gray-900">Output Feed</h2>
                <p className="text-gray-500 mt-1">View all your processed designs and enrichments</p>
            </div>

            {enrichments.length === 0 ? (
                <div className="text-center py-12 bg-white rounded-xl border border-gray-200 border-dashed">
                    <p className="text-gray-500">No enriched products found.</p>
                </div>
            ) : (
                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6">
                    {enrichments.map((item) => (
                        <div key={item.id} className="bg-white rounded-xl border border-gray-200 overflow-hidden hover:shadow-lg transition-all duration-200 group">
                            {/* Image Container */}
                            <div className="aspect-square relative bg-gray-100 overflow-hidden">
                                <img 
                                    src={item.enrich_url} 
                                    alt={`Product ${item.product_id}`}
                                    className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-300"
                                    loading="lazy"
                                />
                                <div className="absolute inset-0 bg-black/0 group-hover:bg-black/10 transition-colors duration-200" />
                                
                                <a 
                                    href={item.enrich_url} 
                                    target="_blank" 
                                    rel="noopener noreferrer"
                                    className="absolute top-3 right-3 p-2 bg-white/90 backdrop-blur-sm rounded-lg opacity-0 group-hover:opacity-100 transition-all duration-200 hover:bg-white text-gray-700 shadow-sm transform translate-y-2 group-hover:translate-y-0"
                                    title="Open full image"
                                >
                                    <ExternalLink className="w-4 h-4" />
                                </a>
                            </div>

                        </div>
                    ))}
                </div>
            )}
        </div>
    );
};

export default OutputFeed;
